import { TransactionIdAndType, TransactionType } from 'vopay';
import { useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '@/hooks/useApi/useFetchCreditCardTransaction';
import useAccountBearer from '@/components/Entities/hooks/useApi/useAccountBearer';
import { useDataFetchIndicator } from '@/hooks';
import { useToast } from '@/providers/Toast.provider';

const CreditCardTransactionContainer: FC<TransactionIdAndType> = ({ TransactionID, Type }: TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { bearer: token } = useAccountBearer(accountId);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const toast = useToast();
  const { t } = useTranslation('translations', { keyPrefix: 'Transaction.Details' });

  const { fetching, creditCardTransaction, fetchCreditCardTransaction } = useFetchCreditCardTransaction();

  useEffect(() => {
    setDataFetchingInfo(fetching, '', 'fullScreen');
  }, [fetching]);

  useEffect(() => {
    if (!token) return;
    if (Type !== TransactionType.CREDIT_CARD) return;

    (async () => {
      try {
        await fetchCreditCardTransaction(TransactionID, token);
      } catch {
        toast.neutral(t('fetchingError', { defaultValue: 'Failed to fetch transaction details' }));
      }
    })();
  }, [TransactionID, token]);

  return <div>{creditCardTransaction && <CreditCardTransactionInfo transaction={creditCardTransaction} />}</div>;
};

export default CreditCardTransactionContainer;
